var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.41077C1 1.18382 1.18382 1 1.41077 1H9.62619C9.85315 1 10.037 1.18382 10.037 1.41077C10.037 1.63773 9.85315 1.82154 9.62619 1.82154H9.07832V2.65489C9.07832 3.87847 8.49451 5.02868 7.50609 5.75059L7.08196 6.06021C6.78262 6.27895 6.78262 6.72617 7.08196 6.94491L7.50609 7.25454C8.4945 7.97647 9.07832 9.1266 9.07832 10.3502V11.1785H9.62619C9.85315 11.1785 10.037 11.3628 10.037 11.5892C10.037 11.8162 9.85315 12 9.62619 12H1.41077C1.18382 12 1 11.8162 1 11.5892C1 11.3628 1.18382 11.1785 1.41077 11.1785H1.95813V10.3502C1.95813 9.12665 2.54245 7.97644 3.53036 7.25454L3.95449 6.94491C4.25434 6.72617 4.25434 6.27895 3.95449 6.06021L3.53036 5.75059C2.54246 5.02866 1.95813 3.87853 1.95813 2.65489V1.82154H1.41077C1.18382 1.82154 1 1.63773 1 1.41077ZM4.01512 5.0872L4.43925 5.39683C5.18788 5.94418 5.18788 7.06147 4.43925 7.60829L4.01512 7.91791C3.23877 8.48529 2.77974 9.38893 2.77974 10.3502V11.1579H8.25686V10.3502C8.25686 9.389 7.79782 8.48523 7.02147 7.91791L6.59786 7.60829C5.84871 7.06144 5.84871 5.94417 6.59786 5.39683L7.02147 5.0872C7.79782 4.51983 8.25686 3.61618 8.25686 2.65491V1.84724H2.77974V2.65491C2.77974 3.61612 3.23877 4.51988 4.01512 5.0872Z",
    fill: "#3E88FF",
    stroke: "#3E88FF",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.622cc987703f454b437848a621f4fba3.svg";
export { ForwardRef as ReactComponent };